import {
  CloseOutlined,
  SearchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { Spin } from "antd";
import {
  default as SignOutIcon,
  default as SignOutLogo,
} from "assets/icons/sign-out.png";
import HeaderVerified from "components/ui/Header/HeaderIsVerified";
import HeaderLinkGames from "components/ui/Header/HeaderLinkGames";
import HeaderMobileIsVerified from "components/ui/Header/HeaderMobileIsVerified";
import HeaderNav from "components/ui/Header/HeaderNav";
import HeaderSub from "components/ui/Header/HeaderSub";
import MenuMobileWrap from "components/ui/Header/MenuMobileWrap";
import { PATH } from "contants/path";
import { useAppSelector } from "hooks/app-hook";
import useOnClickOutside from "hooks/useClickOutSide";
import { useLogout } from "hooks/useLogout";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectLogo } from "store/retrieve";

import HeaderLanguage from "./HeaderLanguage";
import StyledHeader from "./index.style";

const Header = () => {
  const mobileRef = useRef(null);

  const { isLoading, isAuthenticated } = useAppSelector((state) => state.auth);
  const logoUrl = useSelector(selectLogo);

  const [openShowMenuButton, setOpenShowMenuButton] = useState<boolean>(false);

  const [openModalSearch, setOpenModalSearch] = useState<boolean>(false);
  const [openShowMenuMobileButton, setOpenShowMenuMobileButton] =
    useState<boolean>(false);

  const handleShowMenuButton = () => {
    setOpenShowMenuButton(!openShowMenuButton);
  };
  const handleOpenSearch = () => {
    setOpenModalSearch(!openModalSearch);
  };
  const handleShowMenuMobileButton = () => {
    setOpenShowMenuMobileButton(!openShowMenuMobileButton);
  };
  const handleClickMenuOutSide = () => {
    setOpenShowMenuButton(false);
  };

  useOnClickOutside(mobileRef, handleClickMenuOutSide);
  const handleLogout = useLogout();

  return (
    <StyledHeader>
      <div className="header__main">
        <div className="header-first">
          <HeaderNav />
          <HeaderLanguage />
        </div>
        <div className="header-second">
          <div className="header --left">
            <Link to={PATH.home} className="icon">
              <img
                style={{ width: "100%", height: "100%" }}
                src={logoUrl}
                alt=""
              />
            </Link>
            <div className="menu">
              <div
                className="button-mobile"
                ref={mobileRef}
                onClick={handleShowMenuButton}
              >
                <span></span>
                <div
                  className={
                    openShowMenuButton
                      ? "button-mobile-menu --active"
                      : "button-mobile-menu"
                  }
                >
                  <HeaderLinkGames />
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <Spin
              style={{
                display: "flex",
                width: "30%",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          ) : isAuthenticated ? (
            <div className="header --right-authentication">
              {/* <button onClick={handleOpenSearch} className="header__search">
                <SearchOutlined style={{ fontSize: "32px" }} />
              </button> */}
              <HeaderVerified />
              <button className="header__login" onClick={handleLogout}>
                <div className="item">
                  <img src={SignOutIcon} alt="" />
                  Exit
                </div>
              </button>
            </div>
          ) : (
            <div className="header --right">
              {/* <button onClick={handleOpenSearch} className="header__search">
                <SearchOutlined style={{ fontSize: "22px" }} />
              </button> */}
              <Link to={PATH.register} className="header__registration">
                <div className="item">
                  <UserAddOutlined
                    className="icon"
                    style={{ fontSize: "22px" }}
                  />
                  Registration
                </div>
              </Link>
              <Link to={PATH.login} className="header__login">
                <div className="item">
                  <img src={SignOutIcon} alt="" />
                  Login
                </div>
              </Link>
            </div>
          )}
        </div>
        <HeaderSub />
      </div>
      <div className="header__mobile">
        <div className="header__mobile-top">
          {isAuthenticated ? (
            <HeaderMobileIsVerified />
          ) : (
            <div className="--right">
              <Link to={PATH.register} className="header__registration">
                <div className="item">
                  <UserAddOutlined style={{ marginRight: "5px" }} />
                  Registration
                </div>
              </Link>
              <Link to={PATH.login} className="header__login">
                <div className="item">
                  <img
                    src={SignOutLogo}
                    style={{ paddingRight: "7px" }}
                    alt=""
                  />
                  Login
                </div>
              </Link>
            </div>
          )}
        </div>
        <div className="header__mobile-bottom">
          <div className="bottom-menu">
            <button
              onClick={handleShowMenuMobileButton}
              className="button-mobile"
            >
              <span />
            </button>
          </div>
          <div className="bottom-logo">
            <Link className="icon" to={PATH.home}>
              <img
                style={{ width: "100%", height: " 100%" }}
                src={logoUrl}
                alt=""
              />
            </Link>
          </div>
          <button onClick={handleOpenSearch} className="bottom-search">
            <SearchOutlined
              style={{ paddingRight: "10px", fontSize: "32px" }}
            />
          </button>
        </div>
      </div>
      <div
        className={
          openShowMenuMobileButton
            ? "mobile__wrapper --opened"
            : "mobile__wrapper"
        }
      >
        <div className="mobile__wrapper-content">
          <div className="header">
            <div className="header-logo">
              <Link to={PATH.home} className="icon">
                <img
                  style={{ width: "100%", maxWidth: "60px", height: "100%" }}
                  src={logoUrl}
                  alt=""
                />
              </Link>
            </div>
            <button
              onClick={handleShowMenuMobileButton}
              className="header-close"
            >
              <i>
                <CloseOutlined />
              </i>
            </button>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <HeaderLanguage />
          </div>
          {isAuthenticated && (
            <MenuMobileWrap
              name="profile"
              setOpenShowMenuMobileButton={setOpenShowMenuMobileButton}
            />
          )}
          <MenuMobileWrap
            name="game"
            setOpenShowMenuMobileButton={setOpenShowMenuMobileButton}
          />
          <MenuMobileWrap
            name="link"
            setOpenShowMenuMobileButton={setOpenShowMenuMobileButton}
          />
          <div className="menu-bottom">
            <Link to={PATH.user.loyaltyProgram}>Loyalty Program</Link>
            <Link to={PATH.info.terms}>Term of User</Link>
            <Link to={PATH.info.privacy}>Privacy Policy</Link>
          </div>
        </div>
      </div>
      <div
        className={openModalSearch ? "search-modal --active" : "search-modal"}
        id="search-modal"
      >
        <div className="search-modal-background" id="search-modal-background" />
        <div className="search-modal-body">
          <div className="search-modal-body-header">
            <div className="search-icon icon-search">
              <SearchOutlined style={{ color: "white" }} />
            </div>
            <form
              className="search-widget-form"
              id="search-widget-form"
              action="/game/search"
            >
              <input maxLength={100} type="text" placeholder="Game search..." />
            </form>
            <button onClick={handleOpenSearch} className="close-icon">
              <CloseOutlined style={{ color: "white " }} />
            </button>
          </div>
          <div className="search-modal-body-games" id="search-widget-body">
            <div
              className="games_not_found"
              id="games-not-found"
              style={{ display: "none" }}
            >
              No results found{" "}
            </div>
            <div
              className="search-widget-game-list"
              id="search-widget-game-list"
              style={{ display: "none" }}
            />
          </div>
        </div>
      </div>
    </StyledHeader>
  );
};

export default Header;
